import {
  SET_INVITATION_MODAL_ID,
  SET_INVITATION_MODAL_IS_VISIBLE
} from './types'

export const state = {
  isVisible: false
}

export const mutations = {
  [SET_INVITATION_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_INVITATION_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  }
}

export const actions = {
  openInvitationModal ({ commit, dispatch }) {
    dispatch('prepareInvitationModal')
  },
  openInvitationModalInvitation ({ commit, dispatch }, invitationId) {
    return dispatch('prepareInvitationModal')
      .then(() => dispatch('invitationForm/show', { invitationId }, { root: true }))
  },
  closeInvitationModal ({ commit }) {
    commit(SET_INVITATION_MODAL_IS_VISIBLE, false)
  },
  prepareInvitationModal ({ commit, dispatch }) {
    dispatch('invitationForm/reset')
    commit(SET_INVITATION_MODAL_IS_VISIBLE, true)
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/invitations/invitationModal.js